<h1 class="title" translate>HOMEPAGE.SUSPEND.TITLE</h1>
<app-page-wrapper>
  <div
    role="status"
    aria-live="assertive"
    aria-atomic="true"
    class="sr-only"
    [attr.translate-key]="'SUSPEND_PAGE.CARD_1.STATUS_OPENING,COMMON.LOADING_IN_PROGRESS'">
    {{ statusMessage }}
  </div>

  <div class="ic1-my-12">
    <ng-ui-kit-card
      type="summative"
      [title]="'SUSPEND_PAGE.CARD_1.TITLE' | translate"
      [text]="'SUSPEND_PAGE.CARD_1.DESC' | translate"
      [attr.translate-key]="'SUSPEND_PAGE.CARD_1.TITLE,SUSPEND_PAGE.CARD_1.DESC,SUSPEND_PAGE.CARD_1.ARIA_LABEL'"
      [ariaLabelAction]="'SUSPEND_PAGE.CARD_1.ARIA_LABEL' | translate"
      [button]="cardButton">
    </ng-ui-kit-card>
  </div>

  <div class="ic1-my-12">
    <ng-ui-kit-card
      type="summative"
      [title]="'SUSPEND_PAGE.CARD_2.TITLE' | translate"
      [text]="'SUSPEND_PAGE.CARD_2.DESC' | translate"
      [attr.translate-key]="'SUSPEND_PAGE.CARD_2.TITLE,SUSPEND_PAGE.CARD_2.DESC'">
    </ng-ui-kit-card>
  </div>
</app-page-wrapper>

<app-common-modal
  modalId="suspend-confirm-modal"
  [attr.translate-key]="'SUSPEND_PAGE.CARD_1.POPUP_TITLE,SUSPEND_PAGE.CARD_1.POPUP_DESC,COMMON.BUTTON.CONFIRM,COMMON.BUTTON.CANCEL'"
  [title]="'SUSPEND_PAGE.CARD_1.POPUP_TITLE' | translate"
  [(visible)]="showConfirmPopup"
  [config]="{
    size: 'md',
    hideButtons: true,
    autoFocusTarget: 'first-tabbable',
    restoreFocusTarget: false
  }"
  (onClose)="showConfirmPopup = false">
  <p>{{ 'SUSPEND_PAGE.CARD_1.POPUP_DESC' | translate }}</p>
  <div class="ic1-col-12 buttons-container ic1-mt-32 ic1-pr-24 ic1-pb-16">
    <ng-ui-kit-button
      class="cancel-button"
      color="secondary"
      type="button"
      size="sm"
      [label]="'COMMON.BUTTON.CANCEL' | translate"
      (click)="showConfirmPopup = false">
    </ng-ui-kit-button>
    <ng-ui-kit-button
      color="primary"
      type="button"
      size="sm"
      [label]="'COMMON.BUTTON.CONFIRM' | translate"
      (click)="onConfirmSuspend()">
    </ng-ui-kit-button>
  </div>
</app-common-modal>
